import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Import context providers
import { AppConfigProvider } from './contexts/AppConfigContext';
import { WebSocketProvider } from './contexts/WebSocketContext';
import { ConsoleProvider } from './contexts/ConsoleContext';
import { PTTProvider } from './contexts/PTTContext';
import { CameraProvider } from './contexts/CameraContext';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppConfigProvider>
      <WebSocketProvider>
        <ConsoleProvider>
          <PTTProvider>
            <CameraProvider>
              <App />
            </CameraProvider>
          </PTTProvider>
        </ConsoleProvider>
      </WebSocketProvider>
    </AppConfigProvider>
  </React.StrictMode>,
);
